import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Papa from "papaparse";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function YOYParticipation() {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const csvPath = "/static/csv/YOY-RYS-Historical-Participation-2010-2025.csv";
        fetch(csvPath)
            .then((r) => r.text())
            .then((text) => {
                const parsed = Papa.parse(text, { header: true, skipEmptyLines: true });
                const data = parsed.data || [];
                if (!data.length) {
                    setColumns([]);
                    setRows([]);
                    setLoading(false);
                    return;
                }
                const rawKeys = Object.keys(data[0]);
                // prefer to show School Name and Total Participation on the left
                const schoolKey = rawKeys.find((k) => /school\s*name/i.test(k)) || rawKeys[0];
                const totalKey = rawKeys.find((k) => /total/i.test(k)) || rawKeys.find((k) => /participat/i.test(k)) || null;
                const remaining = rawKeys.filter((k) => k !== schoolKey && k !== totalKey);
                const orderedKeys = [schoolKey].concat(totalKey ? [totalKey] : []).concat(remaining);
                const cols = orderedKeys.map((k) => {
                    const header = k.replace(/_/g, " ");
                    const width = /school\s*name/i.test(k) ? 320 : /total/i.test(k) || /participat/i.test(k) ? 160 : 120;
                    return { field: k, headerName: header, width };
                });
                const rowsWithId = data.map((r, idx) => ({ id: idx + 1, ...r }));
                setColumns(cols);
                setRows(rowsWithId);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to load YOY CSV", err);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!columns.length) {
        return (
            <Box sx={{ p: 4 }}>
                <Typography>No YOY participation data found.</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ width: "100%", p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Year-over-Year Participation (2010–2025)
            </Typography>
            <DataGrid rows={rows} columns={columns} autoHeight pagination={false} hideFooter />
        </Box>
    );
}
